import { Box } from '@mui/material';

/**
 * 서비스 브랜드 마크 — 파비콘과 동일한 심볼(육각 토큰 + 검증 체크).
 * `public/favicon.svg` 를 그대로 참조하므로 파비콘을 바꾸면 화면도 함께 바뀐다(단일 출처).
 */
export function BrandMark({ size = 32 }: { size?: number }) {
  return (
    <Box
      component="img"
      src="/favicon.svg"
      alt="디지털자산 검증 인프라"
      sx={{ width: size, height: size, display: 'block', flexShrink: 0 }}
    />
  );
}
